import { store } from 'Store/store.index';
import { browserVersion } from '../utils/browser-info';
import cuid from 'cuid';
import { storageGetItem, storageSetItem, getProductNameForDashboard, needABTest } from '@/utils/utils';
import md5 from 'crypto-js/md5';
import { EVENT_ESIGN } from 'Components/viewer/ui/constants/event.constants.esign';
//let reportPromise = Promise.resolve();
export default class OtelApi {
  constructor() {
    //this.jaegerReporter = null;
    this.globalTracer = null;
    this.FoxitESignActions = [
      "FoxitSign_AgreementStatus",
      "FoxitSign_RequestSignatures",
      "FoxitSign_ManageSignatures",
      "FoxitSign_CreateSignatures",
      "FoxitSign_UseFoxitSign",
      "FoxitSign_ApplyAll"
    ];
  }

  async getJaegerData({
    uuid,
    userID,
    operationName,
    category,
    label,
    osLang,
    osVersion,
    userAgent,
    productName,
    productLang,
    productVersion,
    productType,
    extraInformation,
    moreInfo,
  }) {
    if (this.FoxitESignActions.includes(operationName)) {
      return {
        productName,
        productLang,
        productVersion: '2.0',
        productType,
        userID,
        operationName,
        category,
        label,
        extraInformation: JSON.stringify({
          appName: getProductNameForDashboard(),
          // appVersion: productVersion,
          // appType: await this.getProductType('Phantom Online'),
          // userAgent: userAgent,
        }),
        osLang,
        osVersion,
        uuid,
      };
    }

    let jaegerData = {
      uuid,
      userID,
      operationName,
      category,
      label,
      osLang,
      osVersion,
      productName,
      productLang,
      productVersion,
      productType,
    };

    if (extraInformation) {
      let extraInformation1 = {
        ...extraInformation,
        userAgent: userAgent,
      }
      jaegerData = {
        ...jaegerData,
        extraInformation: JSON.stringify(extraInformation1),
      };
    } else {
      let extraInformation1 = {
        userAgent: userAgent,
      }
      jaegerData = {
        ...jaegerData,
        extraInformation: JSON.stringify(extraInformation1),
      };
    }
    if (moreInfo) {
      jaegerData = {
        ...jaegerData,
        ...moreInfo,
      };
    }

    return jaegerData;
  }
  async getProductType(operationName) {
    if (this.FoxitESignActions.includes(operationName)) {
      return store.foxitSignStore.getFoxitSignProductType();
    }

    return store.accountStore.getSubscribeType();
  }
  getProductName(operationName) {
    if (this.FoxitESignActions.includes(operationName)) {
      return 'Foxit Sign';
    }
    if(EVENT_ESIGN.includes(operationName)){
      return 'Foxit eSign China';
    }

    return getProductNameForDashboard();
  }
  async initOtel(otelBaseUrl) {

    if(this.otelInitialized) return;
    const {  BatchSpanProcessor, WebTracerProvider, OTLPTraceExporter,context,
      propagation,trace,Resource, SemanticResourceAttributes} = await import('./otel.export');

    this.context = context;
    this.propagation = propagation;

    if (!otelBaseUrl) {
      otelBaseUrl = store.appStore.phantomOnlineGlobalConfig && store.appStore.phantomOnlineGlobalConfig.otelBaseUrl || "";
    }

    const collectorOptions = {
      url: otelBaseUrl + '/v1/traces', // url is optional and can be omitted - default is http://localhost:4318/v1/traces
      headers: {}, // an optional object containing custom headers to be sent with each request
      concurrencyLimit: 10, // an optional limit on pending requests
    };
    
    const provider = new WebTracerProvider({
      resource: new Resource({
          [SemanticResourceAttributes.SERVICE_NAME]: 'Phantom Online'
      }),
   });
    const exporter = new OTLPTraceExporter(collectorOptions);
    provider.addSpanProcessor(new BatchSpanProcessor(exporter, {
      // The maximum queue size. After the size is reached spans are dropped.
      maxQueueSize: 100,
      // The maximum batch size of every export. It must be smaller or equal to maxQueueSize.
      maxExportBatchSize: 10,
      // The interval between two consecutive exports
      scheduledDelayMillis: 500,
      // How long the export can run before it is cancelled
      exportTimeoutMillis: 30000,
    }));
    
    provider.register();

    const tracer = trace.getTracer(
      'cloud-editor-tracer'
    );
    this.globalTracer = tracer;
    this.otelInitialized = true;
  }
  getNPSData({ surveyid, channel, operationName, extraInformation, ...common }) {
    let data = {
      ...common,
      operationName,
      surveyid,
      productName: 'survey',
      channel,
    }
    extraInformation && (data['extraInformation'] = JSON.stringify( extraInformation));
    return data;
  }

  async sendJaegerData({ spanName, operationName, extraInformation, moreInfo, category, label, isReturnSpan, surveyid, channel }) {
    return
    // await this.initOtel();

    let jaegerData;
    let userID = '';
    let uuid = storageGetItem(localStorage, 'uuidForJaeger');
    const span = this.globalTracer.startSpan(spanName);
    const { full: language } = store.appStore.lng;
    const userAgent = window.navigator.userAgent;
    const { userInfo } = store.userStore;

    if (!uuid) {
      uuid = cuid();
      storageSetItem(localStorage, 'uuidForJaeger', uuid);
    }
    if (userInfo) {
      if (this.FoxitESignActions.includes(operationName)) {
        userID = md5(userInfo.cUserID).toString();
      } else {
        userID = userInfo.cUserID
      }
    }

    const common = {
      uuid,
      userID,
      osLang: language,
      osVersion: browserVersion ? browserVersion : userAgent,
      userAgent: userAgent,
      productLang: language,
      productVersion: '2.0.0.0',
    }

    if (typeof extraInformation === 'object' && extraInformation !== null) {
      extraInformation.email = userInfo.userEmail;
    }

    // 待AB测试的功能
    let updateExtraInformation = {};
    const ABTestFuncList = ['open_file'];
    let isABTestFunc = false;
    if (ABTestFuncList.includes(spanName) && needABTest()) {
      isABTestFunc = true;
      updateExtraInformation['user_group'] =  store.accountStore.testUserGroup; // 0:角色A, 1:角色B, null:不需要分组;
      if (typeof extraInformation === 'object' && extraInformation !== null) {
        updateExtraInformation = {
          ...updateExtraInformation,
          ...extraInformation,
        };
      }
    }
    if (surveyid === 'nps') {
      jaegerData = this.getNPSData({ surveyid, channel, operationName, extraInformation, ...common })
    } else {
      jaegerData = await this.getJaegerData({
        ...common,
        operationName,
        category,
        label,
        productName: this.getProductName(operationName),
        productType: await this.getProductType(operationName),
        extraInformation: isABTestFunc ? updateExtraInformation : extraInformation,
        moreInfo,
      });
    }

    // add base data
    span.setAttributes({...jaegerData});

    if (isReturnSpan) {
      return span
    }

    span.end();
  }

  activeContext() {
    if(!this.context) 
      return;
    return this.context.active();
  }
  injectTraceHeaders(activeContext) {
    if(!this.context) 
      return;
    let traceHeaders = {};
    activeContext = activeContext || this.context.active();
    this.propagation.inject(activeContext, traceHeaders)
    return traceHeaders;
  }

  startActiveSpan(spanName, callback) {
    if(!this.context) {
      callback();
      return;
    }
    this.globalTracer.startActiveSpan(spanName, (span) => {
      span.setAttribute("foxit.category", "otel_traces");
      callback(span);
    })
  }

  startSpan(spanName, options, context) {
    if(!this.context) 
      return;
    let span = this.globalTracer.startSpan(spanName, options, context);
    span.setAttribute("foxit.category", "otel_traces");
    return span;
  }

  endSpan(span) {
    span&&span.end();
  }

  setSpanStatus(span,status) {
    span&&span.setStatus(status);
  }

  setSpanAttribute(span, name, value) {
    span&&span.setAttribute(name, value)
  }
}
